module.exports = __webpack_public_path__ + "img/geyser-icon.f65c82bc.svg";